<template>
  <div>
    <b-row class="mb-5">
      <b-colxx md="12" class="pl-0">
        <b-dropdown id="title" :text="leftHeaderText" size="lg" variant="outline-secondary" class="dashboard-title-dropdown" :no-caret="dashBoardTypes.length < 2" :menu-class="dashBoardTypes.length < 2 ? 'd-none' : ''">
          <div class="drop-div" v-for="dashBoardType in dashBoardTypes" :key="dashBoardType.title">
            <b-dropdown-item :key="dashBoardType.title" :value="dashBoardType.title" @click="pageDropdownFilter(dashBoardType)" class="dashboard-title-dropdown">
              <div class="custom-title-dropdown">{{ dashBoardType.title }}</div>
            </b-dropdown-item>
            <div class="hidden-text hover-hidden-text" v-if="dashBoardType && dashBoardType.hover && dashBoardType.hover != ''">
              <div v-html="dashBoardType.hover"></div>
            </div>
          </div>
        </b-dropdown>

        <div class="hidden-text" v-if="dashBoardTypeSelected && dashBoardTypeSelected.hover && dashBoardTypeSelected.hover != ''">
          <div v-html="dashBoardTypeSelected.hover"></div>
        </div>
      </b-colxx>
    </b-row>

    <b-row class="mb-10">
      <b-colxx md="12" class="pl-0 pr-0 btn-space-between align-items-center">
        <div class="col col-7 p-0">
          <div  v-if="displayFilters">
          <!-- Country Selector -->
          <b-dropdown v-if="showFilters.countries" id="country-select" size="xs" variant="outline-secondary" class="filter-select-btn" :title="$t('datapoint.countryFilter')" ref="country-select">
            <template slot="button-content">
              <!-- <img src="" class="mr-6" /> -->
              <span class="country-icon static-color mr-6"></span>
              Countries
              <span v-if="checkedCountries && checkedCountries.length > 0" class="selected-filter ml-5">{{ checkedCountries.length }}</span>
            </template>
            <b-colxx md="12">
              <div :class="{ search: true, 'mobile-view': true }" ref="searchContainer" @mouseenter="isSearchOver = true" @mouseleave="isSearchOver = false">
                <form autocomplete="off">
                  <b-input placeholder="Enter a country to filter" @input="filterCountryData" v-model="searchCountryKeyword" autocomplete="off" type="search"/>
                </form>
              </div>
            </b-colxx>
            <vue-perfect-scrollbar class="scroll picker-container" :settings="{ suppressScrollX: true, wheelPropagation: false }">
              <b-row>
                <b-colxx md="12" class="mt-1">
                  <b-form-group>
                    <b-form-checkbox-group v-model="checkedCountries" stacked>
                      <b-form-checkbox v-for="d in countries" :key="d" :value="d" ref="cbItem" :title="d" v-show="searchCountry(d)">{{ d }}</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>
                </b-colxx>
              </b-row>
            </vue-perfect-scrollbar>
            <div class="filter-footer">
              <b-button v-if="checkedCountries && checkedCountries.length > 0" @click="clearCountryFilter" class="text-sm btn-link">Clear </b-button>
              <b-button v-if="checkedCountries && countries && checkedCountries.length !== countries.length" @click="selectAllCountry" class="text-sm btn-link">Select All </b-button>
              <b-link variant="outline-secondary" @click="applyCountryFilter" class="btn-blue">Apply </b-link>
            </div>
          </b-dropdown>
          <!-- Country Selector -->

          <!-- Sites Selector -->
          <b-dropdown v-if="showFilters.sites" id="site-select" size="xs" variant="outline-secondary" :title="$t('datapoint.siteFilter')" class="ml-8 mr-8 filter-select-btn" ref="site-select">
            <template slot="button-content">
              <span class="site-icon static-color mr-6"></span>
              Sites
              <span v-if="checkedSites && specificSiteId && checkedSites.length > 0" class="selected-filter ml-5">{{ checkedSites.length }}</span>
            </template>
            <b-colxx md="12">
              <div :class="{ search: true, 'mobile-view': true }" ref="searchContainer" @mouseenter="isSearchOver = true" @mouseleave="isSearchOver = false">
                <form autocomplete="off">
                  <b-input placeholder="Enter a site name/site ID to filter" @input="filterSitesData" v-model="searchKeyword" autocomplete="off" type="search"/>
                </form>
              </div>
            </b-colxx>
            <vue-perfect-scrollbar class="scroll" :settings="{ suppressScrollX: true, wheelPropagation: false }">
              <b-row>
                <b-colxx md="12" class="mt-1">
                  <b-form-group>
                    <b-form-checkbox-group v-model="checkedSites" stacked>
                      <b-form-checkbox v-for="d in sites" :key="d" :value="d" ref="cbItem" :title="d + ' (' + getSiteID(d) + ')'" v-show="searchSiteID(d)">{{ d }} ({{ getSiteID(d) }})</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>
                </b-colxx>
              </b-row>
            </vue-perfect-scrollbar>
            <div class="filter-footer">
              <b-button v-if="checkedSites && checkedSites.length > 0" @click="clearSiteFilter" class="text-sm btn-link">Clear </b-button>
              <b-button v-if="checkedSites && sites && checkedSites.length !== sites.length" @click="selectAllSites" class="text-sm btn-link">Select All </b-button>
              <b-link variant="outline-secondary" @click="applySitesFilter" class="btn-blue">Apply </b-link>
            </div>
          </b-dropdown>
          <!-- Sites Selector -->

          <!-- Participants Button -->
          <b-dropdown id="participant-select" v-if="participantsBtn && showFilters.participants" size="xs" variant="outline-secondary" class="mr-8 filter-select-btn" :title="$t('datapoint.participantsFilter')" ref="participant-select">
            <template slot="button-content">
              <span class="participants-icon static-color mr-6"></span>
              Participants
              <span v-if="checkedParticipants && checkedParticipants.length > 0" class="selected-filter ml-5">{{ checkedParticipants.length }}</span>
            </template>
            <b-colxx md="12">
              <div :class="{ search: true, 'mobile-view': true }" ref="searchContainer" @mouseenter="isSearchOver = true" @mouseleave="isSearchOver = false">
                <form autocomplete="off">
                  <b-input placeholder="Enter a participant to filter" @input="filterParticipantsData" v-model="searchParticipantsKeyword" autocomplete="off" type="search"/>
                </form>
              </div>
            </b-colxx>
            <vue-perfect-scrollbar class="scroll picker-container" :settings="{ suppressScrollX: true, wheelPropagation: false }">
              <b-row>
                <b-colxx md="12" class="mt-1">
                  <b-form-group>
                    <b-form-checkbox-group v-model="checkedParticipants" stacked>
                      <b-form-checkbox v-for="d in stateParticipants" :key="d" :value="d" ref="cbItem" :title="d" v-show="searchParticipant(d)">{{ setParticipantName(d) }}</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>
                </b-colxx>
              </b-row>
            </vue-perfect-scrollbar>
            <div class="filter-footer">
              <b-button v-if="checkedParticipants && checkedParticipants.length > 0" @click="clearParticipantFilter" class="text-sm btn-link">Clear </b-button>
              <b-button v-if="checkedParticipants && participants && checkedParticipants.length !== participants.length" @click="selectAllParticipants" class="text-sm btn-link">Select All </b-button>
              <b-link variant="outline-secondary" @click="applyParticipantsFilter" class="btn-blue">Apply </b-link>
            </div>
          </b-dropdown>
          <!-- Participants Button -->

          <!-- Date Button -->
          <b-dropdown v-if="showFilters.date" id="date-select" size="xs" variant="outline-secondary" title="Month Filter" class="filter-select-btn date-picker-select" style="width: 210px;">
            <template slot="button-content" v-if="dateSelect && dateSelect.length > 0">
              <img src="/static/img/calendar.svg" class="mr-6" @click="calendarShow = true" />
              <div @click="calendarShow = true">{{ dateSelect[0].display }} - {{ dateSelect[1].display }}</div>
            </template>
            <b-colxx md="12">
              <MonthSlider :calendarShow="calendarShow" title="Month Filter" :dataPicker="dataPicker" v-if="studyData.studyStartDate" :studyStartDate="studyData.studyStartDate" @init="initMonth" @onDragEnd="getRangeMonth" />
            </b-colxx>
          </b-dropdown>
          <!-- Date Button -->
          </div>
        </div>
        <div class="col col-5 p-0 text-right">
          <!-- Benchmark Data-->
          <span class="pr-10" v-if="canSysAdminAccess || canStudyAdminAccess || canStudyManagerAccess || canDMAccess || canCRAAccess || canInterviewer || canPharmacovigilance || canQuality || canBSTATAccess || canCraUBAccess">
            <span id="benchmarkdata">
              <button id="benchmarkdatabtn" class="btn settings-btn cursor_pointer" @click="isEnabledDisableButton && awsCognitoAuthentication && awsCognitoAuthentication === true ? openBenchMarkDetails() : getBenchmarkDisabledModal()"><img class="lokavant-logo" src="/static/img/lokavant.png" />Benchmark Data</button>
            </span>
          </span>
          <!-- End Benchmark Data-->
          <!-- Export Button -->
          <span class="pr-10" v-if="exportBtn">
            <a
              class="header-buttons-right cursor_pointer"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              :class="{
                'settings-btn': !(user.userRole !== 'Rater' && user.userRole !== 'Interviewer' && currentCompliance && currentCompliance.adherence) && (canSponserAccess() || canQualityAccess() || canRaterAccess() || canInterviewerAccess() || !activeParticipants || activeParticipants.length <= 0)
              }"
              v-if="!(!(user.userRole !== 'Rater' && user.userRole !== 'Interviewer' && currentCompliance && currentCompliance.adherence) && (canSponserAccess() || canQualityAccess() || canRaterAccess() || canInterviewerAccess() || !activeParticipants || activeParticipants.length <= 0))"
              >Export Data</a
            >
            <div class="dropdown-menu download-dropdown-box p-0">
              <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="exportStudyData()" v-if="!canPharmacovigilanceAccess() && !(canSponserAccess() || canQualityAccess() || canRaterAccess() || canInterviewerAccess() || !activeParticipants || activeParticipants.length <= 0)">
                Study Data
              </span>
              <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="exportComplianceData()" v-if="user.userRole !== 'Rater' && user.userRole !== 'Interviewer' && currentCompliance && currentCompliance.adherence">
                Compliance Report
              </span>
            </div>
          </span>
          <!-- Export Button -->

          <!-- Setting Button -->
          <span class="pr-10" v-if="settingsBtn">
            <a v-if="specificSiteId && specificSiteId.length == 0 && (canSysAdminAccess || canStudyAdminAccess || canStudyManagerAccess || canSupportAccess || canDownloadPrototype() || ((canSysAdminAccess || canStudyAdminAccess) && studyData.ios))" :class="`header-buttons-right settings-btn cursor_pointer`" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <img src="/static/img/settings.svg" class="mr-6" />
              Settings
            </a>
            <div class="dropdown-menu download-dropdown-box p-0" style="width:150px">
              <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="dataTransfer()" v-if="canSysAdminAccess || canStudyAdminAccess || canStudyManagerAccess">
                Data Transfer
                <span class="data-transfer-btn off" v-if="!transferEnabled">Off</span>
                <span class="data-transfer-btn on" v-if="transferEnabled">On</span>
              </span>
              <span v-if="canDownloadPrototype()" class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="downloadProtoType()">
                Download Prototype
              </span>
              <span v-if="(canSysAdminAccess || canStudyAdminAccess) && studyData.ios" class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="submitToAppStore()">
                Submit to App Store
              </span>
            </div>
          </span>
          <!-- Setting Button -->
        </div>
        <!-- Open benchmark iframe modal-->
        <b-modal id="openButtonModal" class="openButtonModal" ref="additionalDetailsModal" hide-footer scrollable>
          <iframe :src="displaylokovantUrl" frameborder="0" height="836px" width="100%"></iframe>
        </b-modal>
        <!-- Close benchmark iframe modal-->
        <!-- open modal when benchmark button is disabled -->
        <b-modal id="benchmarkDisabledModal" hide-header hide-footer class="benchmark-modal">
          <div class="modal-content">
            Benchmark clinical trial data provides the ability to compare the operational performance and status of your study to other similar studies in the industry. This capability provides aggregated study benchmark data from > 1300 studies from our partner Lokavant. Available KPIs for benchmarking include Enrollment, Site Management, Protocol Adherence, Adverse Events, Monitoring, Data
            Management and Site Journey. This benchmark data can be filtered by Therapeutic Area, Trial Phase or Region. For more information or to turn this feature on for your study, please contact your Business Development Representative.
            <div class="mod-footer mt-34 text-center">
              <b-button type="button" class="btn btn-primary" @click="closeBenchmarkModal()">OK </b-button>
            </div>
          </div>
        </b-modal>
        <!-- Modal End -->
      </b-colxx>
    </b-row>

    <!--Submit to APP store confirmation modal -->
    <submitToAppStoreConfirModal ref="submitToAppStoreConfirmModal" />

    <div class="modal fade" id="dataTransferModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content pt-15 pr-15 pl-40 pb-40">
          <div>
            <i class="fa fa-times cancel-image" aria-hidden="true" v-on:click="closeTransferModal()"></i>
          </div>
          <div class="pt-15 pr-25">
            <div class="sftp-header1">
              Use SFTP to automate your raw data transfer
            </div>
            <div class="sftp-header2">
              Schedule your data transfer to deliver at your preferred frequency
            </div>
            <div class="data-input-div pl-60 pr-60">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="pt-10 survey_title">Host name</label>
                <div class="form-group">
                  <input type="text" class="form-control input-md input-color" v-model="sftp.host" />
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <span class="fs-12">
                  *If no port is specified, port 22 will be used by default. To specify a port, use the following format: www.example.com:####
                </span>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="pt-10 survey_title">Remote Location</label>
                <div class="form-group">
                  <input type="text" class="form-control input-md input-color" v-model="sftp.transferPath" />
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="pt-10 survey_title">Username</label>
                <div class="form-group">
                  <input type="text" class="form-control input-md input-color" v-model="sftp.username" />
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="pt-10 survey_title">Password</label>
                <div class="form-group">
                  <input type="password" class="form-control input-md input-color" v-model="sftp.password" />
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="pt-10 survey_title">Frequency</label>
                <div class="form-group">
                  <select class="form-control input-md input-color" v-model="frequencyCron">
                    <option value="0 0 9 * * *">Daily</option>
                    <option value="0 0 9 * * TUE">Weekly</option>
                    <option value="0 0 9 1 * *">Monthly</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <span v-if="frequencyCron === '0 0 9 * * *'">
                  Data transfers will occur at 9:00 AM PST every day.
                </span>
                <span v-if="frequencyCron === '0 0 9 * * TUE'">
                  Data transfers will occur at 9:00 AM PST every Tuesday.
                </span>
                <span v-if="frequencyCron === '0 0 9 1 * *'">
                  Data transfers will occur at 9:00 AM PST on the 1st of the month.
                </span>
              </div>
              <div class="clearfix"></div>
              <div>
                <div class="continue-transfer">
                  <button class="btn download_btn br-25" v-on:click="continueTransfer()">
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="dataTransferDetailsModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content pt-15 pr-15 pl-40 pb-40">
          <div>
            <i class="fa fa-times cancel-image" aria-hidden="true" v-on:click="closeTransferDetailsModal()"></i>
          </div>
          <div class="pt-15 pr-25">
            <div class="sftp-header1">
              Use SFTP to automate your raw data transfer
            </div>
            <div class="sftp-header2">
              Schedule your data transfer to deliver at your preferred frequency
            </div>
            <div class="data-input-div pl-30 pr-30 pt-30">
              <div class="details-div col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <ul>
                  <li class="connection-label">
                    <span class="pull-right">Status:&nbsp;</span>
                  </li>
                  <li class="connection-content">
                    <span
                      :class="{
                        disconnect: connection.status === 'Failed' && (connection.displayMessage.indexOf('Permission Error') !== -1 || connection.displayMessage.indexOf('Failed') !== -1)
                      }"
                      >{{ connection.displayMessage }}&nbsp;&nbsp;</span
                    >
                    <span class="modify" v-if="connection.status === 'Failed' && (connection.displayMessage.indexOf('Permission Error') !== -1 || connection.displayMessage.indexOf('Failed') !== -1)" v-on:click="retry()">Retry</span>
                  </li>
                </ul>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 details-div">
                <ul>
                  <li class="connection-label">
                    <span class="pull-right">Frequency:&nbsp;</span>
                  </li>
                  <li class="connection-content">
                    <span>{{ connection.frequency }}&nbsp;</span>
                    <span v-if="connection.timezone === 'America/Los_Angeles'">PST</span>
                  </li>
                </ul>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 details-div">
                <ul>
                  <li class="connection-label">
                    <span class="pull-right">Last transfer:&nbsp;</span>
                  </li>
                  <li class="connection-content" v-if="connection.lastTransfer">
                    <span>{{ connection.lastTransferTime | convertToPST }}&nbsp;</span>
                    <span v-if="connection.timezone === 'America/Los_Angeles'">PST</span>
                  </li>
                  <li class="connection-content" v-if="!connection.lastTransfer">
                    <span
                      >Scheduled - {<span>{{ connection.scheduledAt | convertToPST }}</span
                      >}&nbsp;</span
                    >
                    <span v-if="connection.timezone === 'America/Los_Angeles'">PST</span>
                  </li>
                </ul>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 details-div" v-if="connection.status !== 'InProgress' || connection.status !== 'Started'">
                <ul>
                  <li class="connection-label">&nbsp;</li>
                  <li class="connection-content">
                    <span class="modify" v-on:click="transferNow()">Transfer now</span>
                  </li>
                </ul>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pt-30 details-div">
                <ul>
                  <li class="disconnect connection-label" v-on:click="disconnectTransfer()">
                    <span class="pull-right">Disconnect</span>
                  </li>
                  <li>
                    <span class="modify pl-40" v-on:click="modifyTransferLocation()">Modify transfer location</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dashboard-static-desc" v-if="!zoomGraphValue && !isEdroDashboard">
      The analytics provided reflects participants that are utilizing the THREAD Platform only.<span v-if="displayLastRefreshDate()" class="ml-3">Data updated hourly | Last update: {{ dashboardRefreshDate }}</span>
    </div>
    <div class="dashboard-static-desc" v-else-if="!zoomGraphValue && isEdroDashboard">
      The data provided reflects participants that are utilizing the THREAD Platform only.
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import { AclRule } from "vue-acl";
import MonthSlider from "../form-components/month-slider";
import { SPONSOR, QUALITY, SYSTEM_ADMIN, STUDY_ADMIN, STUDY_MANAGER, RATER, INTERVIEWER, DM, PHV, CRA, BSTAT, CraUB, SUPPORT } from "@/constants/authRoles";
import toastr from "toastr";
import * as dManagement from "../../services/visualization/data-management";
import moment from "moment";
import localStorageService from "@/services/localStorage";
import submitToAppStoreConfirModal from "@/components/common/submit-app-store-confirmation-modal";
import swal from "sweetalert2";
import { EDRO_DASHBOARD_ROUTE_NAMES } from "@/constants/edroDashboardRoutes";
import { ANALYTICS_DASHBOARDS } from "@/constants/dashboards";
import _isEmpty from "lodash/isEmpty";
import * as commonHelper from "@/components/services/common-helper";
import axios from "axios";

export default {
  components: {
    MonthSlider,
    submitToAppStoreConfirModal
  },
  props: {
    leftHeaderText: { type: String },
    fpiBtn: { type: Boolean },
    exportBtn: { type: Boolean, default: true },
    callApiCompleted: { type: Boolean },
    participantsBtn: { type: Boolean },
    sites: { type: Array },
    checkedSitesApply: { type: Array },
    countries: { type: Array },
    checkedCountriesApply: { type: Array },
    fpi: { type: Array },
    selectedFpi: { type: String },
    dataPicker: { type: Array, value: [] },
    specificSiteId: { type: Array, default: () => [] },
    zoomGraphValue: { type: String },
    settingsBtn: { type: Boolean, default: true },
    toggleFeatures: { type: Array, default: () => [] },
    studyData: { type: Object, default: () => {} }
  },
  data() {
    return {
      studyId: this.$route.params.studyId,
      isCheckAll: false,
      todayDate: moment()
        .format("DD MMM YYYY")
        .toUpperCase(),
      participants: [],
      checkedParticipantsApply: [],
      siteListInParticipants: [],
      checkedParticipants: [],
      checkedSites: [],
      checkedCountries: [],
      checkedCountriesByParticipants: [],
      checkedSitesByParticipants: [],
      checkedFpis: [],
      searchKeyword: "",
      searchCountryKeyword: "",
      dateSelect: [],
      fromDate: null,
      toDate: null,
      searchParticipantsKeyword: "",
      pattern: new RegExp("^", "i"),
      patternCountry: new RegExp("^", "i"),
      patternParticipant: new RegExp("^", "i"),
      activeParticipants: [],
      calendarShow: false,
      dashBoardTypes: [],
      dashBoardTypeSelected: {},
      allSitesWithDetails: [],
      stateParticipants: this.participants,
      transferEnabled: false,
      sftp: {},
      frequencyCron: "0 0 9 * * *",
      sftpId: "",
      sftpObject: {},
      connection: {},
      dbData: {},
      complianceData: null,
      currentCompliance: null,
      selectedSite: null,
      filterTriggeredBy: null,
      participantsFetched: false,
      edroDashboards: [],
      isEnabledDisableButton: false,
      displaylokovantUrl: "",
      lokavantTargetUrl: "",
      showFilters: {
        sites: true,
        countries: true,
        date: false,
        participant: false
      },
      dashboardWithFilters: ["Enrollment Dashboard", "Compliance Dashboard", "Retention Dashboard"]
    };
  },
  watch: {
    callApiCompleted: async function(newVal, oldVal) {
      this.callApiCompleted = newVal;
      if (this.participantsBtn && this.callApiCompleted && this.sites && this.sites.length > 0) {
        await this.getSiteDetails();
      }
    },
    countries: function(newVal) {
      if (newVal) {
        this.checkedCountries = this.countries;
      }
    },
    checkedSites: function(newVal) {
      this.checkedSites = newVal;
    },
    checkedSitesApply: function(newVal) {
      this.checkedSitesApply = newVal;
      this.checkedSites = newVal;
      if (this.participantsBtn) {
        this.generateParticipantList();
      } else {
        const checkedCountries = new Set();
        this.checkedSites.forEach(siteName => {
          const siteData = this.allSitesWithDetails.find(s => s.name === siteName);
          const countrySiteName = siteData && siteData.countryNameList && siteData.countryNameList[0];
          checkedCountries.add(countrySiteName);
        });
        this.checkedCountries = Array.from(checkedCountries);
      }
    },
    sites: function(newVal) {
      if (newVal && newVal.length > 0) {
        this.checkedSites = this.sites;
        this.getSiteDetails();
      }
    },
    checkedCountries: function(newVal) {
      this.checkedCountries = newVal;
    },
    checkedParticipants: function(newVal) {
      this.checkedParticipants = newVal;
    },
    checkedParticipantsApply: function(newVal) {
      this.checkedParticipantsApply = newVal;
      this.checkedParticipants = newVal;
    },
    checkedCountriesApply: function(newVal) {
      this.checkedCountriesApply = newVal;
      if (this.participants.length === this.checkedParticipants.length) {
        this.checkedCountries = newVal;
      } else {
        this.checkedCountries = this.checkedCountriesByParticipants;
      }
    },
    participants: function(values) {
      this.participants = values;
      let temporaryParticipants = [];
      const result = [];
      if (Array.isArray(values) && values.length > 0) {
        values.map(v => {
          const payload = {
            order: this.setParticipantName(v, true) ? this.setParticipantName(v, true) : v,
            id: v
          };
          temporaryParticipants.push(payload);
        });
      }

      temporaryParticipants = _.orderBy(temporaryParticipants, [d => _.toLower(d["order"])], ["asc"]);
      temporaryParticipants.map(tp => result.push(tp.id));

      this.stateParticipants = result;
    },
    specificSiteId: function(value) {
      this.specificSiteId = value;
      if (this.specificSiteId.length > 0) {
        this.getSiteDetails();
      }
    },
    studyData: function(value) {
      if (this.canSysAdminAccess || this.canStudyAdminAccess || this.canDMAccess || this.canStudyManagerAccess) {
        this.getTransferStatus();
      }
    },
    toggleFeatures: function(value) {
      this.setDashboardTypes();
    }
  },
  methods: {
    openBenchMarkDetails() {
      const accessToken = localStorageService.getItem("accessToken_benchmark");
      const idToken = localStorageService.getItem("idToken_benchmark");
      const lokavantUrl = this.lokavantTargetUrl;
      this.displaylokovantUrl = `${lokavantUrl}&access_token=${accessToken}&id_token=${idToken}`;
      this.$refs.additionalDetailsModal.show();
    },
    filterCountryData() {
      let searchTxt = this.searchCountryKeyword;
      searchTxt = searchTxt.replace(/[.()+]/g, "\\$&");
      this.patternCountry = new RegExp("^" + searchTxt, "i");
    },
    filterParticipantsData() {
      let searchTxt = this.searchParticipantsKeyword;
      searchTxt = searchTxt.replace(/[.()+]/g, "\\$&");
      this.patternParticipant = new RegExp("^" + searchTxt, "i");
    },
    filterSitesData() {
      let searchTxt = this.searchKeyword;
      searchTxt = searchTxt.replace(/[.()+]/g, "\\$&");
      this.pattern = new RegExp("^" + searchTxt, "i");
    },
    getRangeMonth(payload) {
      this.dateSelect = payload;
      payload.detailSite = this.allSitesWithDetails;
      this.fromDate = payload[0].value;
      this.toDate = payload[1].value;
      if (this.participantsBtn) {
        this.generateParticipantList();
      }
      this.filterTriggeredBy = "date";
      this.$emit("onApplyRangeMonth", payload);
    },
    initMonth(payload) {
      this.dateSelect = payload;
    },
    selectAllCountry() {
      this.searchCountryKeyword = "";
      this.checkedCountries = this.countries;
    },
    selectAllParticipants() {
      this.searchParticipantsKeyword = "";
      this.checkedParticipants = this.participants;
    },
    clearCountryFilter() {
      this.searchCountryKeyword = "";
      this.checkedCountries = [];
    },
    clearParticipantFilter() {
      this.searchParticipantsKeyword = "";
      this.checkedParticipants = [];
    },
    selectAllSites() {
      this.searchKeyword = "";
      this.checkedSites = this.sites;
    },
    clearSiteFilter() {
      this.searchKeyword = "";
      this.checkedSites = [];
    },
    applyCountryFilter() {
      let checkedCountries = [];
      checkedCountries = checkedCountries.concat(this.checkedCountries);
      const payload = {
        checked: checkedCountries,
        isCheckAll: this.checkedCountries.length === this.countries.length,
        detailSite: this.allSitesWithDetails
      };

      if (payload["isCheckAll"]) {
        this.checkedSites = this.sites;
        this.checkedParticipants = this.participants;
      }

      this.filterTriggeredBy = "country";
      this.$emit("onApplyCountry", payload);
      this.$refs["country-select"].hide(true);
    },
    applySitesFilter() {
      let allChecked = [];
      allChecked = allChecked.concat(this.checkedSites);

      const payload = {
        checked: allChecked,
        isCheckAll: this.sites.length === this.checkedSites.length,
        detailSite: this.allSitesWithDetails
      };

      if (payload["isCheckAll"]) {
        this.checkedParticipants = this.participants;
      }

      this.filterTriggeredBy = "site";
      this.$emit("onApplySites", payload);
      this.$refs["site-select"].hide(true);
    },
    fpiFilter(value) {
      if (this.fpi) {
        this.fpi.forEach(each => {
          if (each.value == value) {
            this.selectedFpi = each.name;
          }
        });
      }
      this.$emit("onApplyFpi", "fpi", value);
    },
    pageDropdownFilter(value) {
      this.dashBoardTypeSelected = value;
      switch (value.title) {
        case "Enrollment Dashboard":
          this.$router.push({
            name: "vis-enrollment",
            params: { studyId: this.studyId }
          });
          break;
        case "Compliance Dashboard":
          this.$router.push({
            name: "vis-study-compliance",
            params: { studyId: this.studyId }
          });
          break;
        case "Engagement Dashboard":
          this.$router.push({
            name: "vis-study-engagement",
            params: { studyId: this.studyId }
          });
          break;
        case "Study Performance Dashboard":
          this.$router.push({
            name: "vis-study-executive",
            params: { studyId: this.studyId }
          });
          break;
        case "Retention Dashboard":
          this.$router.push({
            name: "vis-study-completion",
            params: { studyId: this.studyId }
          });
          break;
        case "Data Management Dashboard":
          this.$router.push({
            name: "vis-data-management",
            params: { studyId: this.studyId }
          });
          break;
      }
    },
    searchSiteID(name) {
      let allSitesData = (this.allSitesWithDetails.length > 0) ? this.allSitesWithDetails : this.sitesData;
      return this.searchKeyword
        ? _.find(allSitesData, allSitesWithDetails => {
            return (allSitesWithDetails.userSiteId.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) >= 0 || allSitesWithDetails.name.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) >= 0) && allSitesWithDetails.name === name;
          })
        : true;
    },
    searchCountry(name) {
      return this.searchCountryKeyword
        ? _.find(this.countries, country => {
            return country.toLowerCase().indexOf(this.searchCountryKeyword.toLowerCase()) >= 0 && country === name;
          })
        : true;
    },
    searchParticipant(name) {
      return this.searchParticipantsKeyword
        ? _.find(this.participants, participant => {
            return participant.toLowerCase().indexOf(this.searchParticipantsKeyword.toLowerCase()) >= 0 && participant === name;
          }) ||
            _.find(this.siteListInParticipants, participant => {
              return participant.participantName ? participant.participantName.toLowerCase().indexOf(this.searchParticipantsKeyword.toLowerCase()) >= 0 && participant.participantId === name : false;
            })
        : true;
    },
    getSiteID(searchKeyword, filterKey = "name", responseKey = "userSiteId") {
      let allSitesData = (this.allSitesWithDetails && this.allSitesWithDetails.length > 0) ? this.allSitesWithDetails : this.sitesData;
      const siteData = _.find(allSitesData, allSitesWithDetails => {
        return allSitesWithDetails[filterKey] === searchKeyword;
      });
      return _.get(siteData, responseKey, "");
    },
    async getSiteDetails() {
      if (this.specificSiteId.length > 0) {
        this.allSitesWithDetails = [];
        let siteData = null;
        if(this.checkCurrentSiteOrStudy && this.siteById && this.siteById.body){
          siteData = this.siteById;
          this.setSpecificSiteData(siteData);
        }
        else{
          this.specificSiteId.map(site => {
          this.$api.getSiteDetailsFact(this.studyId, site).then(response => {
            siteData = response;
            this.setSpecificSiteData(siteData);
            this.$store.dispatch("saveSiteByIdData", response);
          });
        });
        }
      } else {
        if (this.sitesData && this.sitesData.length > 0 && this.checkCurrentSiteOrStudy) {
          //API call is not needed
          this.setSitesData(this.sitesData);
        } else {
          this.$api.getSitesFact(this.studyId).then(
            response => {
              this.setSitesData(response.body);
              this.$store.dispatch("saveSitesData", response.body);
              this.$store.dispatch("saveStudyId", this.studyId);
              commonHelper.setSiteId();
            },
            error => {
              this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the list of sites");
            }
          );
        }
      }
    },
    generateParticipantList() {
      // don't generate if still don't get response from getParticipants API
      if (!this.participantsBtn || this.siteListInParticipants.length <= 0) {
        return;
      }
      let participantList = [];
      const countrySelected = new Set();
      let siteSelected = new Set();
      participantList = this.siteListInParticipants.filter(sp => {
        const siteData = this.allSitesWithDetails.find(s => s.id === sp.siteId);
        let countrySiteName = "";

        if (Array.isArray(this.specificSiteId) && this.specificSiteId.length) {
          countrySiteName = siteData && siteData.countryList[0].countryName ? siteData.countryList[0].countryName : "";
        } else {
          countrySiteName = siteData && siteData.countryNameList && siteData.countryNameList[0];
        }
        const siteName = siteData.name;
        let siteOrCountryChecked = true;
        if (this.filterTriggeredBy === "country") {
          siteOrCountryChecked = this.checkedCountries.includes(countrySiteName);
        } else if (this.filterTriggeredBy === "site") {
          siteOrCountryChecked = this.checkedSites.includes(siteName);
        }
        const dateChecked = this.fromDate && sp.invitationDate ? moment(sp.invitationDate).isBetween(moment(this.fromDate, "YYYY-MM-DD"), moment(this.toDate, "YYYY-MM-DD"), undefined, "[]") : true;
        const participantsChecked = this.checkedParticipants.length === this.participants.length || this.filterTriggeredBy !== "participant" ? true : this.checkedParticipants.includes(sp.participantId);

        if (siteOrCountryChecked && dateChecked && participantsChecked) {
          countrySelected.add(countrySiteName);
          siteSelected.add(siteName);
        }
        return siteOrCountryChecked && dateChecked && participantsChecked;
      });

      if (siteSelected.size > this.checkedSites.length) {
        siteSelected = new Set(this.checkedSites);
      }
      participantList = _.orderBy(Array.from(participantList), [participant => (participant.participantName ? participant.participantName.toLowerCase() : participant.participantId.toLowerCase())]);
      this.checkedParticipants = participantList.map(fp => fp.participantId);
      this.checkedCountries = Array.from(countrySelected);
      this.checkedSites = Array.from(siteSelected);
      this.checkedCountriesByParticipants = Array.from(countrySelected);
      this.checkedSitesByParticipants = Array.from(siteSelected);
    },
    async getAllParticipants() {
      if (!this.participantsBtn && !this.callApiCompleted && !this.allSitesWithDetails.length <= 0 && !this.participantsFetched) {
        return;
      }
      this.participantsFetched = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };
      let dbData = null;
      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }
      if (this.analyticsUsersData && this.analyticsUsersData.body && this.checkCurrentSiteOrStudy) {
        dbData = this.analyticsUsersData;
      } else {
        const data = await this.$api.getAllUsers(params);
        if (data.ok) {
          dbData = data;
          this.$store.dispatch("saveAnalyticsUserData", dbData);
          this.$store.dispatch("saveStudyId", this.studyId);
        }
      }
      if (dbData.ok) {
        const result = dbData.body;
        if (result.data && result.data.length > 0) {
          response = _.orderBy(Array.from(result.data), [participant => (participant.userDefinedId ? participant.userDefinedId.toLowerCase() : participant.id.toLowerCase())]);
          response = response.filter(res => {
            const siteData = this.allSitesWithDetails.find(s => s.id === res.siteId);
            if (!siteData) {
              return false;
            }
            const siteName = siteData.name;
            const siteChecked = this.sites && this.sites.includes(siteName);
            return res.enrollmentDate && siteChecked;
          });
        }
      }
      this.participants = response.map(p => p.id);
      this.siteListInParticipants = response.map(p => ({
        participantId: p.id,
        siteId: p.siteId,
        participantName: p.userDefinedId,
        patientId: p.patientId,
        invitationDate: p.invitationDate
      }));
      this.checkedParticipants = this.participants;
      this.generateParticipantList();
      this.$emit("onFetchedParticipants", this.siteListInParticipants);
    },
    getSiteData(rawData, searchKeyword, filterKey = "name", responseKey = "userSiteId") {
      const siteData = _.find(rawData, allSitesWithDetails => {
        return allSitesWithDetails[filterKey] === searchKeyword;
      });
      return _.get(siteData, responseKey, "");
    },
    applyParticipantsFilter() {
      let checkedParticipants = [];
      checkedParticipants = checkedParticipants.concat(this.checkedParticipants);
      const payload = {
        checkedParticipants,
        isCheckAll: this.participants.length === this.checkedParticipants.length
      };
      if (checkedParticipants.length === 0) {
        this.checkedSites = [];
        this.checkedCountries = [];
      }
      this.filterTriggeredBy = "participant";
      this.$emit("onApplyParticipants", payload);
      this.$refs["participant-select"].hide(true);
    },
    canSponserAccess() {
      this.$acl.change(`${SPONSOR}`);
      return this.$acl.check("userAccess");
    },
    canQualityAccess() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    canRaterAccess() {
      this.$acl.change(`${RATER}`);
      return this.$acl.check("userAccess");
    },
    canInterviewerAccess() {
      this.$acl.change(`${INTERVIEWER}`);
      return this.$acl.check("userAccess");
    },
    canPharmacovigilanceAccess() {
      this.$acl.change(`${PHV}`);
      return this.$acl.check("userAccess");
    },
    canDownloadPrototype() {
      return !!(this.canSysAdminAccess || this.canStudyAdminAccess || this.canStudyManagerAccess || this.canSupportAccess);
    },
    exportParticipantData() {
      this.$api.exportParticipantDashboardFact(this.studyId).then(response => {
        toastr.success(response.data.message);
      });
    },
    getStudyDashboardData() {
      if (this.analyticsDashboardData && this.analyticsDashboardData.body && this.checkCurrentSiteOrStudy) {
        this.dbData = this.analyticsDashboardData.body;
        this.setAnalyticsDashboardData();
      } else {
        this.$api.getStudyDashboardData(this.studyId).then(response => {
          this.dbData = response.body;
          this.setAnalyticsDashboardData();
          this.$store.dispatch("saveDashboardData", response);
          this.$store.dispatch("saveStudyId", this.studyId);
          if (this.isSiteRole) {
            commonHelper.setSiteId();
          }
        }).catch(() => {
          this.$toastr.error("Error while getting dashboard data");
        });
      }
    },
    changeComplianceSite(siteObj) {
      if (siteObj && siteObj.id) {
        this.currentCompliance = _.filter(this.complianceData, o => o.siteDetails.id === siteObj.id);
      } else if (!this.currentCompliance || this.currentCompliance.length === 0) {
        this.currentCompliance = _.filter(this.complianceData, o => o.siteDetails.id === "allSites");
      }
      if (this.currentCompliance && this.currentCompliance.length > 0) {
        this.currentCompliance = this.currentCompliance[0];
        this.currentCompliance.adherence = _.orderBy(this.currentCompliance.adherence, ["index"]);
        this.currentCompliance.completedTasks = _.orderBy(this.currentCompliance.completedTasks, ["index"]);
      }
    },
    setParticipantName(participantId, isGet = false) {
      let name = "";
      const dataSource = this.siteListInParticipants;

      // Check if list participant not empty and in Array format
      const isEmptyListParticipant = _.isEmpty(dataSource) && !Array.isArray(dataSource);

      if (isEmptyListParticipant) {
        return;
      }

      // filter participant name by participant id
      name = dataSource.filter(ds => ds.participantId === participantId);

      if (_.isEmpty(name) || _.isEmpty(name[0].participantName)) {
        if (isGet) {
          return null;
        } else {
          return participantId;
        }
      }

      return name[0].participantName;
    },
    submitToAppStore() {
      this.$refs.submitToAppStoreConfirmModal.show();
    },
    downloadProtoType() {
      this.$api.downloadPrototypesFact(this.studyId).then(response => {
        if (response.body.android) {
          window.open(response.body.android, "_blank");
        }
        if (response.body.ios) {
          window.open(response.body.ios, "_blank");
        }
        if (!response.body.android && !response.body.ios) {
          toastr.error("Prototype is not yet available. Please try again later.");
        } else if (response.body.android === null) {
          toastr.error("Android prototype is not yet available. Please try again later.");
        } else if (response.body.ios === null) {
          toastr.error("iOS prototype is not yet available. Please try again later.");
        }
      });
    },
    dataTransfer() {
      if (this.transferEnabled) {
        this.getConnectionDetails();
        window.$("#dataTransferDetailsModal").modal("show");
      } else {
        this.sftp = {};
        this.frequencyCron = "0 0 9 * * *";
        window.$("#dataTransferModal").modal("show");
      }
    },
    exportComplianceData() {
      this.$api.exportComplianceData(this.studyId).then(response => {
        toastr.success(response.bodyText);
      });
    },
    exportStudyData() {
      this.$router.push({
        name: "data-export",
        params: { studyId: this.studyId }
      });
    },
    getTransferStatus() {
      this.$api.getSftpTransferStatus(this.studyId).then(
        response => {
          if (response.body.length !== 0) {
            this.transferEnabled = response.body[0].enabled;
            this.sftpId = response.body[0].sftpId;
          } else {
            this.transferEnabled = false;
            this.sftpId = "";
          }
        },
        () => {
          toastr.error("Error while getting SFTP transfer status");
        }
      );
    },

    disconnectTransfer() {
      swal({
        title: "Are you sure you want to disconnect the scheduled data transfer?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$api.disconnectTransfer(this.studyId, this.sftpId).then(
            () => {
              this.getTransferStatus();
              window.$("#dataTransferDetailsModal").modal("hide");
            },
            () => {
              toastr.error("Error while disconnecting scheduled data transfer");
            }
          );
        } else {
          window.$("#dataTransferDetailsModal").modal("hide");
        }
      });
    },
    closeTransferModal() {
      this.sftp = {};
      this.frequencyCron = "0 0 9 * * *";
      window.$("#dataTransferModal").modal("hide");
    },
    closeTransferDetailsModal() {
      window.$("#dataTransferDetailsModal").modal("hide");
    },
    closeBenchmarkModal() {
      window.$("#benchmarkDisabledModal").modal("hide");
    },
    continueTransfer() {
      if (!this.sftp.host || !this.sftp.username || !this.sftp.password || !this.sftp.transferPath) {
        toastr.error("Please fill all the fields.");
      } else {
        if (this.sftp.host.indexOf(":") !== -1) {
          const hostArray = this.sftp.host.split(":");
          this.sftp.host = hostArray[0];
          this.sftp.port = hostArray[1];
        } else {
          this.sftp.port = 22;
        }
        this.sftpObject.timezone = "America/Los_Angeles";
        this.sftpObject.frequencyCron = this.frequencyCron;
        this.sftpObject.sftpCred = this.sftp;
        if (this.transferEnabled) {
          swal({
            title: "Are you sure you want to modify the scheduled data transfer?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#b8c7ce",
            cancelButtonColor: "#34537d",
            confirmButtonText: "Cancel",
            cancelButtonText: "Yes"
          }).then(({ dismiss }) => {
            if (dismiss === "cancel") {
              this.$api.updateSftpTransferDetails(this.studyId, this.sftpId, this.sftpObject).then(
                () => {
                  this.getTransferStatus();
                  window.$("#dataTransferModal").modal("hide");
                },
                () => {
                  toastr.error("Unable to connect. Please check your settings.");
                }
              );
            } else {
              window.$("#dataTransferModal").modal("hide");
            }
          });
        } else {
          this.$api.testSftpStatus(this.studyId, this.sftpObject).then(
            () => {
              window.$("#dataTransferModal").modal("hide");
              window.$("#dataTransferConfirmModal").modal("show");
            },
            () => {
              toastr.error("Unable to connect. Please check your settings.");
            }
          );
        }
      }
    },
    modifyTransferLocation() {
      this.$api.modifyTransfer(this.studyId, this.sftpId).then(
        response => {
          this.sftp.username = "";
          this.sftp.password = "";
          this.sftp.hostname = "";
          this.sftp.transferPath = response.body.transferPath;
          this.frequencyCron = response.body.frequencyCron;
          window
            .$("#dataTransferDetailsModal")
            .modal("hide")
            .on("hidden.bs.modal", function() {
              window.$("#dataTransferModal").modal("show");
            });
        },
        () => {
          toastr.error("Error while getting SFTP details");
        }
      );
    },
    getConnectionDetails() {
      this.$api.getConnectionDetails(this.studyId, this.sftpId).then(
        response => {
          this.connection = response.body;
          if (this.connection.frequencyCron === "0 0 9 * * *") {
            this.connection.frequency = "Daily, 9.00 AM";
          } else if (this.connection.frequencyCron === "0 0 9 * * TUE") {
            this.connection.frequency = "Weekly, Tuesdays, 9.00 AM";
          } else if (this.connection.frequencyCron === "0 0 9 1 * *") {
            this.connection.frequency = "Monthly,1st of every month, 9.00 AM";
          }
          if (this.connection.lastTransfer) {
            this.connection.lastTransferTime = new Date(this.connection.lastTransfer);
          } else if (this.connection.scheduledTransfer) {
            this.connection.scheduledAt = new Date(this.connection.scheduledTransfer);
          }
        },
        () => {
          toastr.error("Error while getting SFTP connection details");
        }
      );
    },
    async setDashboardTypes() {
      if (this.isEdroDashboard) {
        const params = {
          studyId: this.studyId
        };

        try {
          const res = await this.$api.getEdroActivities(params);
          if (res.ok) {
            const result = res.body;
            if (!_isEmpty(result.data)) {
              if (result.data.activities && result.data.activities.length > 0) {
                result.data.activities.forEach(obj => {
                  if (["Forced Spirometry"].includes(obj.activityTitle)) {
                    this.edroDashboards.push({ title: obj.activityTitle });
                  }
                });
              }
            }
          }
        } catch (err) {}

        this.dashBoardTypes = this.edroDashboards;
      } else {
        this.dashBoardTypes = ANALYTICS_DASHBOARDS;
      }
    },
    getBenchMarkStatusDetails() {
      if (this.benchMarkData && this.benchMarkData.data && this.checkCurrentSiteOrStudy) {
        this.isEnabledDisableButton = this.benchMarkData.data.enabled;
        this.lokavantTargetUrl = this.benchMarkData.data.targetUrl;
      } else {
        this.$api.getBenchmarkStatus(this.studyId).then(
          response => {
            if (response && response.body && response.body.data) {
              this.isEnabledDisableButton = response.body.data.enabled;
              this.lokavantTargetUrl = response.body.data.targetUrl;
              this.$store.dispatch("saveBenchMarkData", response.body);
              this.$store.dispatch("saveStudyId", this.studyId);
              commonHelper.setSiteId();
            }
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting bench mark status");
          }
        );
      }
    },
    getBenchmarkDisabledModal() {
      window.$("#benchmarkDisabledModal").modal("show");
    },
    displayLastRefreshDate() {
      if (this.dashboardWithFilters.includes(this.leftHeaderText) && !!this.dashboardRefreshData) {
        return true;
      } else {
        return false;
      }
    },
    getAnalyticsDashboardRefreshTime() {
      const clientId = localStorageService.getItem("clientId");
      const apiURL = `${process.env.VUE_APP_API_BASE_URL}/api/v1/analytics/studies/${this.studyId}/analytics-data/refresh-time`;
      axios({
        url: apiURL,
        method: "GET",
        headers: {
          clientId: clientId,
          Authorization: localStorageService.getItem("token")
        }
      }).then(
        response => {
          let data = response.data;
          if (data) {
            let refreshTime = data.last_completion_date;
            let utcRefreshTime = moment.utc(refreshTime).format("DD MMM YYYY HH:mm:ss") + " UTC";
            if (!this.dashboardRefreshData) {
              this.$store.dispatch("saveDashboardRefreshData", utcRefreshTime.toUpperCase());
              this.$store.dispatch("saveStudyId", this.studyId);
            } else if (this.dashboardRefreshData !== utcRefreshTime.toUpperCase()) {
              this.clearAnalyticsStore();
              this.$store.dispatch("saveDashboardRefreshData", utcRefreshTime.toUpperCase());
              this.$store.dispatch("saveStudyId", this.studyId);
            }
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting analytics refresh time.");
        }
      );
    },
    clearAnalyticsStore() {
      //Commom API Data
      this.$store.dispatch("saveDashboardData", {});
      this.$store.dispatch("saveStudyId", "");
      this.$store.dispatch("saveSitesData", []);
      this.$store.dispatch("saveBenchMarkData", {});

      //Enrollment Dashboard
      this.$store.dispatch("saveEnrollmentData", {});
      this.$store.dispatch("saveEconsentUploadedData", {});
      this.$store.dispatch("saveTopScreenFailuareReasons", {});
      this.$store.dispatch("saveQuizData", {});
      this.$store.dispatch("saveRecruitementData", {});
      this.$store.dispatch("saveAnalyticsUserData", {});

      //Complaince Dashboard
      this.$store.dispatch("saveSensorComplianceData", {});
      this.$store.dispatch("saveOverallCollectionData", {});
      this.$store.dispatch("saveComplianceInsightScore", {});
      this.$store.dispatch("saveOverallCollectionMissingData", {});
      this.$store.dispatch("saveNonCompliantActivities", {});
      this.$store.dispatch("saveTelehealthVisitsDuration", {});
      this.$store.dispatch("saveComplianceRateOverTime", {});
      this.$store.dispatch("saveStudyComplianceData", "");
      this.$store.dispatch("saveStudyParticipantComplianceData", "");
      this.$store.dispatch("saveOverallCollectionParticipantData", {});
      this.$store.dispatch("saveGraphicComplianceData", {});
      this.$store.dispatch("saveAnalyticsUserData", {});
      this.$store.dispatch("saveDashboardRefreshData", "");
      this.$store.dispatch("saveSiteByIdData", {});
      this.$store.dispatch("saveAllEnrollmentData", {});
      this.$store.dispatch("saveCancelledThVisitData", {});

      //Retension Dashboard
      this.$store.dispatch("saveParticipantProgressData", {});
      this.$store.dispatch("saveDiscontinuationActivity", {});
      this.$store.dispatch("saveOtherDiscontinuationReasons", {});
      this.$store.dispatch("saveParticipantStudyProgression", {});
      this.$store.dispatch("saveMiletonesData", {});
    },
    setSitesData(sitesDbData){
      this.allSitesWithDetails = _.orderBy(sitesDbData, [site => site.name.toLowerCase()]);
      dManagement.setSiteDetails(this.allSitesWithDetails);
      if (!this.participantsFetched) {
        this.getAllParticipants();
      }
    },
    getRefreshTime(){
      if (this.dashboardWithFilters.includes(this.leftHeaderText)) {
        this.getAnalyticsDashboardRefreshTime();
      }
    },
    setSpecificSiteData(siteData) {
      this.allSitesWithDetails = this.allSitesWithDetails.concat([siteData.body]);
      dManagement.setSiteDetails(this.allSitesWithDetails);
      this.getAllParticipants();
    },
    setAnalyticsDashboardData(){
      if (this.dbData.compliance) {
        this.complianceData = this.dbData.compliance;
        this.selectedSite = { id: "allSites", name: "All Sites" };
        if (this.user.userRole === "Pi" || this.user.userRole === "SubPi" || this.user.userRole === "SiteDataLock" || this.user.readOnly || this.user.userRole === "StudyCoordinator" || this.user.userRole === "HomeHealth" || this.user.userRole === "Rater" || this.user.userRole === "CallCenter") {
          if (this.dbData.compliance && this.dbData.compliance[0]) {
            this.selectedSite = this.dbData.compliance[0].siteDetails;
            this.changeComplianceSite(this.selectedSite);
          }
        } else {
          this.changeComplianceSite();
        }
      }
      if (this.dbData.participantStatus) {
        this.activeParticipants = _.filter(this.dbData.participantStatus, o => o.key !== "imported" && o.key !== "invited" && o.value > 0);
      }
    }
  },
  computed: {
    ...mapGetters(["user", "awsCognitoAuthentication", "analyticsDashboardData", "studyIdValue", "sitesData", "benchMarkData", "analyticsUsersData", "dashboardRefreshData", "siteById", "selectedSiteId"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    },
    canDMAccess() {
      this.$acl.change(`${DM}`);
      return this.$acl.check("userAccess");
    },
    canCRAAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    },
    canBSTATAccess() {
      this.$acl.change(`${BSTAT}`);
      return this.$acl.check("userAccess");
    },
    canQuality() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    canInterviewer() {
      this.$acl.change(`${INTERVIEWER}`);
      return this.$acl.check("userAccess");
    },
    canPharmacovigilance() {
      this.$acl.change(`${PHV}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    },
    isEdroDashboard() {
      if (EDRO_DASHBOARD_ROUTE_NAMES.includes(this.$route.name)) {
        return true;
      }
      return false;
    },
    getSiteId() {
      return localStorage.getItem("selectedSite");
    },
    isSiteRole() {
      return commonHelper.isSiteUser(this.user.userRole);
    },
    checkCurrentSiteOrStudy() {
      return this.studyIdValue === this.studyId && (!this.isSiteRole || (this.isSiteRole && this.getSiteId === this.selectedSiteId));
    },
    dashboardRefreshDate() {
      return this.dashboardRefreshData ? this.dashboardRefreshData : "";
    },
    displayFilters(){
      return this.dashboardWithFilters.includes(this.leftHeaderText);
    }
  },
  async mounted() {
    if(!this.checkCurrentSiteOrStudy){
      this.clearAnalyticsStore();
    }
    this.getRefreshTime();
    this.checkedSites = this.checkedSitesApply ? this.checkedSitesApply : 'all';
    this.checkedCountries = this.checkedCountriesApply ?  this.checkedCountriesApply :'all';
    this.checkedParticipants = this.checkedParticipantsApply;
    this.setDashboardTypes();
    this.dashBoardTypeSelected = _.find(this.dashBoardTypes, dashBoardType => {
      return dashBoardType.title === this.leftHeaderText;
    });

    this.getStudyDashboardData();
    if (this.canSysAdminAccess || this.canStudyAdminAccess || this.canStudyManagerAccess || this.canDMAccess || this.canCRAAccess || this.canInterviewer || this.canPharmacovigilance || this.canQuality || this.canBSTATAccess || this.canCraUBAccess) {
      this.getBenchMarkStatusDetails();
    }
  }
};
</script>
<style lang="scss">
.openButtonModal .modal-header .close {
  font-size: 30px;
  margin-bottom: 10px;
}
</style>
<style scoped lang="scss">
.lokavant-logo {
  width: 18px;
  height: 14px;
  margin-right: 4px;
  margin-bottom: 1px;
}

#site-select .dropdown-menu {
  min-width: 175px;
  max-width: 350px;
}

.custom-button {
  height: 30px;
  padding: 3px 5px 5px 5px;
  border-radius: 4px;
  border: solid 1px #c5d1d6;
  background: transparent;
  color: #666669;
}

.custom-title-dropdown {
  font-size: 14px;
  width: 100%;
  padding: 0;
  color: #000000;
  font-family: "RobotoMedium";
}

.hover-hidden-text {
  display: inherit !important;
  justify-content: center;
  position: absolute;
  color: var(--study-primary-color);
  width: 100%;
  z-index: 400 !important;
}

.header-buttons-right {
  border-radius: 4px;
  border: solid 1px #4c8ce4;
  background-color: #ffffff;
  color: #4c8ce4 !important;
  padding: 6px 10px 8px;

  &.settings-btn {
    background-color: #666669;
    border: solid 1px #666669;
    color: white !important;
  }
}

.data-transfer-btn {
  color: white;
  position: absolute;
  height: 20px;
  top: 6px;
  right: 10px;
  line-height: 1.4;
  padding: 3px;
  border-radius: 4px;
  font-size: 11px;

  &.off {
    background-color: #c4c4c4;
  }

  &.on {
    background-color: #4c8ce4;
  }
}

.dashboard-title-dropdown {
  + .hover-hidden-text {
    div:before {
      content: "";
      display: block;
      position: absolute;
      left: calc(-4% + -2px);
      bottom: 83%;
      width: 0;
      height: 0;
      border: 10px solid transparent;
      border-bottom-color: #c5d1d6;
      transform: rotate(270deg);
      transform: rotate(270deg);
    }

    div:after {
      content: "";
      display: block;
      position: absolute;
      left: calc(-3% - 1%);
      bottom: calc(85% - 2px);
      width: 0;
      height: 0;
      border: 9px solid transparent;
      border-bottom-color: #eff3f5;
      left: calc(95% + - 1px);
      transform: rotate(270deg);
    }

    div {
      border: 1px solid #c5d1d6;
      border-radius: 5px;
      padding: 8px;
      background-color: #eff3f5;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
      width: 460px;
      position: absolute !important;
      left: 224px !important;
      top: -28px !important;

      span:nth-child(2) {
        display: block;
      }

      span:first-child {
        font-weight: bold;
        font-size: 13px;
        letter-spacing: -0.5px;
      }

      span:nth-child(2),
      ul {
        color: #666669;
        font-size: 12px;
        margin-bottom: 0;
        list-style: disc !important;
      }
    }
  }
}

.cancel-image {
  float: right;
  cursor: pointer;
}

.sftp-header1 {
  font-size: 16px;
  font-family: "RobotoMedium";
  color: "#4a4a4a";
}

.sftp-header2 {
  font-size: 14px;
  font-family: "RobotoRegular";
  color: "#666669";
}

.modal-dialog {
  max-width: 600px !important;
}

.continue-button {
  width: 60%;
  margin: 0 auto !important;
}

.continue-button button {
  width: 48%;
  margin-top: 30px;
  cursor: pointer;
}

.continue-transfer {
  width: 40%;
  margin: 0 auto !important;
}

.continue-transfer button {
  width: 100%;
  margin-top: 50px;
  cursor: pointer;
}

.disconnect {
  color: #f16559 !important;
  font-family: "RobotoRegular" !important;
  cursor: pointer;
}

.modify {
  color: #4c8ce4;
  cursor: pointer;
}

.connection-label {
  font-family: "RobotoBold";
  float: left;
  width: 33%;
}

.connection-content {
  width: 66%;
  float: left;
}

.transfer-on {
  background-color: #48bf7a !important;
}

.cancel_btn {
  background-color: #959fa4;
  color: #ffffff;
}

.text-font {
  font-size: 16px;
  font-family: "RobotoMedium";
}

.details-div ul {
  list-style-type: none;
  padding: 0;
}

@media (max-width: 1024px) {
  .margin-responsive {
    margin-left: 0px;
    margin-right: 0px;
  }
}

@media (min-width: 1024px) and (max-width: 1200px) {
  .participant-enrollment {
    margin-left: 60px;
  }
}

.btn-primary {
  background-color: #4c8ce4;
  border-color: #4c8ce4;
  border-radius: 25px;
  font-weight: normal;
  font-size: 14px;
}

.download_btn {
  background-color: #4c8ce4;
  color: #ffffff;
  cursor: pointer;
}

.pop-color {
  color: #666669 !important;
}

.close-btn {
  background: #d3dfe4;
  color: #666669;
}

.input-color {
  background-color: #f7f7f7;
  border: 1px solid #cccccc;
  border-radius: 3px;
}

.disabled {
  opacity: 0.5;
}

.benchmark-modal {
  .modal-content {
    font-family: "RobotoRegular";
    font-size: 16px;
    padding: 40px 10px;
    box-shadow: none;
  }

  .btn {
    padding: 10px 70px;
    color: white;

    &:focus {
      box-shadow: none;
    }

    &:active {
      box-shadow: none !important;
    }
  }
}

#benchmarkdata {
  button {
    font-family: "RobotoRegular" !important;

    &:disabled {
      border-color: #4c8ce4;
      background-color: white;
      color: #4c8ce4;
      opacity: 0.6;
    }
  }
}
</style>
